import { render, staticRenderFns } from "./ExamRecord.vue?vue&type=template&id=04311fc8&scoped=true&"
import script from "./ExamRecord.vue?vue&type=script&lang=js&"
export * from "./ExamRecord.vue?vue&type=script&lang=js&"
import style0 from "./ExamRecord.vue?vue&type=style&index=0&id=04311fc8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04311fc8",
  null
  
)

export default component.exports